import styled from "styled-components";

export const StyledButton = styled.button`
  background-color: var(--danger);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-danger, #ffffff);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;

  height: ${props => props.height ? props.height : '50px'};
  width: ${props => props.width ? props.width : '150px'};

  font-weight: 600;
  margin-right: 32px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02);
  }    
`;

export const StyledButtonDelete = styled.button`
  background: var(--danger);
  border: 2px solid var(--danger);
  border-radius: 16px;
  color: var(--text-on-danger, #ffffff);
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 600;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-2px);
    border-color: color-mix(in srgb, var(--danger) 80%, #000);
    background: color-mix(in srgb, var(--danger) 88%, #000);
    color: var(--text-on-danger, #ffffff);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;
